export function buildCheckMenuItems({
  options = [],
  selectedValue,
  onSelect,
  onAfterSelect,
  getValue,
  getLabel,
  getIsActive,
}) {
  return options.map((option) => {
    const value = typeof getValue === 'function' ? getValue(option) : option?.value;
    const label = typeof getLabel === 'function' ? getLabel(option) : option?.label;
    const isActive = typeof getIsActive === 'function'
      ? !!getIsActive(option, selectedValue)
      : selectedValue === value;

    return {
      label,
      iconClass: 'check',
      isActive,
      onClick: () => {
        onSelect?.(value, option);
        onAfterSelect?.();
      }
    };
  });
}

